import { useState } from "react";
import { Link } from "react-router-dom";
import pdlogo from "../../icons/appLogo.png";
import {
  Menu,
  Search,
  X,
  Mail,
  Phone,
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
} from "lucide-react";
import "./css/tailwind.css";

function Navbar() {
  const mId = localStorage.getItem("mId");
  const machineType = localStorage.getItem("machineType");

  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [
    { to: "/offerLanding", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];
  const socialIcons = [
    { id: "linkedin", Icon: Linkedin },
    { id: "instagram", Icon: Instagram },
    { id: "facebook", Icon: Facebook },
    { id: "twitter", Icon: Twitter },
  ];

  return (
    <nav className="flex tw justify-between items-center sticky top-0 bg-white z-20 h-16">
      <img src={pdlogo} alt="Logo" className="h-10" />

      {/* Search (desktop only) */}
      <div className="hidden items-center relative">
        <Search className="absolute left-3 size-5 text-gray-500" />
        <input
          type="text"
          placeholder="Search"
          className="border border-gray-400 rounded-md py-2 pl-10 w-72 lg:w-96"
        />
      </div>

      {/* Desktop Links */}
      <div className="hidden lg:flex gap-16">
        {navLinks.map(({ to, label }) => (
          <Link
            key={to}
            to={to}
            className="font-semibold no-underline text-xl text-[#0072B1]"
          >
            {label}
          </Link>
        ))}
      </div>

      <button
        className="lg:hidden border-none bg-transparent"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Menu className="border-none" />
      </button>

      {isOpen && (
        <div
          className="fixed inset-0 z-10 bg-black/20 backdrop-blur-sm"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Mobile Menu (sliding) */}
      <div
        className={`fixed top-0 right-0 h-full w-2/3 bg-white shadow-lg transform transition-transform duration-300 ease-in-out lg:hidden flex flex-col items-start p-6 gap-2 z-20 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="w-full flex my-3 justify-end">
          <X
            className="text-[#ED1A68] size-6 cursor-pointer"
            onClick={() => setIsOpen(false)}
          />
        </div>
        {navLinks.map(({ to, label }) => (
          <div key={to} className="w-full">
            <Link
              to={to}
              onClick={() => setIsOpen(false)}
              className="font-semibold no-underline text-md text-[#0072B1] hover:text-pink-600 transition-colors"
            >
              {label}
            </Link>
            <div className="bg-gray-300 h-[1px] w-full" />
          </div>
        ))}
        <p className="font-semibold text-lg mt-3 text-gray-800">Contact Info</p>
        <div className="flex flex-col gap-y-3">
          <div className="flex items-center gap-x-2">
            <Mail className="size-4 -mt-4 text-[#0072B1]" />
            <p className="text-gray-600 text-sm">info@punnyadhara.com</p>
          </div>
          <div className="flex items-center gap-x-2">
            <Phone className="size-4 -mt-4 text-[#0072B1]" />
            <p className="text-gray-600 text-sm">+91 9818989980</p>
          </div>
        </div>
        <Link
          to={`/${machineType}/${mId}`}
          className="text-center no-underline rounded-full p-2 text-white text-sm w-full my-6 bg-[#0072B1]"
        >
          Order Here
        </Link>
        <div className="flex gap-x-3 justify-center items-center mx-auto w-full">
          {socialIcons.map(({ id, Icon }) => (
            <div
              key={id}
              className="rounded-full p-2 bg-[#ED1A68] flex items-center justify-center"
            >
              <Icon className="size-4 text-white" />
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
